import { ApiError } from "@9amhealth/openapi";
import { ErrorCode } from "src/constants/errorCodes";
import reportErrorSentry from "src/lib/reportErrorSentry";

export const extractErrorCode = (error: unknown): ErrorCode => {
  try {
    const apiError = error as ApiError;
    const code = apiError?.body?.code;
    if (code !== undefined && code !== null) {
      return `${code}` as ErrorCode;
    }
  } catch (e: unknown) {
    reportErrorSentry(e);
  }

  return ErrorCode.unknown;
};
